import { render, staticRenderFns } from "./ServicesCard.vue?vue&type=template&id=66d9c32f&scoped=true"
import script from "./ServicesCard.vue?vue&type=script&lang=ts"
export * from "./ServicesCard.vue?vue&type=script&lang=ts"
import style0 from "./ServicesCard.vue?vue&type=style&index=0&id=66d9c32f&prod&lang=scss&scoped=true"
import style1 from "./ServicesCard.vue?vue&type=style&index=1&id=66d9c32f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d9c32f",
  null
  
)

export default component.exports